var render = function render(){
  var _vm$chemContainers;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "id": "recent-containers-table"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "var(--font-size-200, 1.5rem)"
    }
  }, [_vm._v("Chemical Inventory Recently Added")]), _vm._v(" "), _c('b-table', {
    ref: "table",
    class: {
      'table-pause-scroll': _vm.isBusy || ((_vm$chemContainers = _vm.chemContainers) === null || _vm$chemContainers === void 0 ? void 0 : _vm$chemContainers.length) < 1
    },
    attrs: {
      "striped": "",
      "hover": "",
      "sticky-column": true,
      "no-local-sorting": true,
      "no-sort-reset": true,
      "show-empty": "",
      "busy": _vm.isBusy,
      "fields": _vm.getFields,
      "items": _vm.updateInstitutionalChemicalContainers,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "current-page": "1",
      "data-test": "recent-table",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('RaftBusy', {
          attrs: {
            "busy-text": "Loading..."
          }
        })];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_c('p', [_vm._v(_vm._s(_vm.emptyStateText))])])];
      }
    }, {
      key: "cell(field_chemical_container_id)",
      fn: function (data) {
        return [_c('b-link', {
          attrs: {
            "href": _vm.buildContainerUrl({
              container: data.item
            }),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(data.item.field_chemical_container_id))])];
      }
    }, {
      key: "cell(chemical_container_edit)",
      fn: function (data) {
        return [_c('b-link', {
          attrs: {
            "href": _vm.buildContainerUrl({
              container: data.item,
              edit: true
            }),
            "target": "_blank"
          }
        }, [_vm._v("Edit")])];
      }
    }, {
      key: "cell(og_audience[0].title)",
      fn: function (data) {
        return [data.item.og_audience[0] ? _c('a', {
          attrs: {
            "href": _vm.buildNodeUrl(data.item.og_audience[0].drupal_internal__nid)
          }
        }, [_vm._v("\n        " + _vm._s(data.item.og_audience[0].title))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_space.title)",
      fn: function (data) {
        return [data.item.field_chemical_space ? _c('a', {
          attrs: {
            "href": _vm.buildNodeUrl(data.item.field_chemical_space.drupal_internal__nid)
          }
        }, [_vm._v("\n        " + _vm._s(data.item.field_chemical_space.title))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_name_preferred)",
      fn: function (data) {
        return [data.item.field_chemical_name_preferred ? _c('a', {
          attrs: {
            "href": _vm.buildChemicalTypeUrl(data.item)
          }
        }, [_vm._v(_vm._s(data.item.field_chemical_name_preferred))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_container_owner.field_prof_display_name)",
      fn: function (data) {
        return [data.item.field_chemical_container_owner ? _c('a', {
          attrs: {
            "href": _vm.buildUserUrl(data.item.field_chemical_container_owner)
          }
        }, [_vm._v("\n        " + _vm._s(data.item.field_chemical_container_owner.field_prof_display_name))]) : _vm._e()];
      }
    }, {
      key: "cell(field_chemical_note)",
      fn: function (data) {
        return [_vm._v("\n      " + _vm._s(_vm.formatters.formatNotes(data.item.field_chemical_note)) + "\n    ")];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }